import { CallAPI } from "../../apiManager/ApiCall";
import { store } from "../store";
import { setAuth } from "../slices/authSlice";

const mergeAuthProfile = (profile) => {
  if (!profile) return profile;

  const currentAuth = store.getState().auth || {};
  store.dispatch(
    setAuth({
      ...currentAuth,
      ...profile,
    })
  );

  return profile;
};

export const GetCurrentUserProfileCall = async () => {
  try {
    const response = await CallAPI({
      url: "user",
      method: "GET",
    });

    const profile = response?.data ?? null;
    return mergeAuthProfile(profile);
  } catch (error) {
    return null;
  }
};

export const UpdateCurrentUserProfileCall = async (body) => {
  try {
    const response = await CallAPI({
      url: "user/profile",
      method: "PUT",
      body,
    });

    return mergeAuthProfile(response);
  } catch (error) {
    return { status: 400 };
  }
};

export const UploadCurrentUserProfileImageCall = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await CallAPI({
      url: "user/upload_profile",
      method: "POST",
      formData,
      contentType: null,
    });

    if (response?.success) {
      await GetCurrentUserProfileCall();
    }

    return response;
  } catch (error) {
    return { status: 400 };
  }
};
